import { Messages } from "./Messages";

export class NamirasoftAccountClient
{
    private inited: boolean = false;
    private domain: string;
    constructor(domain: string)
    {
        this.domain = domain;
        this.onLoggedin = this.onLoggedin.bind(this);
        this.onLoggedout = this.onLoggedout.bind(this);
        this.start = this.start.bind(this);
        this.stop = this.stop.bind(this);
        this.handleEvent = this.handleEvent.bind(this);
    }
    onLoggedin(data: any)
    {
        data;
    }
    onLoggedout(data: any)
    {
        data;
    }
    start()
    {
        if (this.inited)
            return;
        this.inited = true;
        window.addEventListener("message", this.handleEvent);
    }
    stop()
    {
        this.inited = false;
        window.removeEventListener("message", this.handleEvent);
    }

    handleEvent(event: MessageEvent<any>)
    {
        if (event.origin.startsWith(this.domain))
        {
            try
            {
                let data = event.data;
                if (typeof data === "string")
                    data = JSON.parse(data);
                if (Messages.isLogin(data))
                {
                    if (this.onLoggedin)
                        this.onLoggedin(data);
                }
                else if (Messages.isLogout(data))
                {
                    if (this.onLoggedout)
                        this.onLoggedout(data);
                }
            } catch (error)
            {
            }
        }
    }

    login()
    {
        const windowFeatures = "fullscreen=yes";
        window.open(this.domain, "_blank", windowFeatures);
    }
    logout()
    {
        const windowFeatures = "fullscreen=yes";
        window.open(this.domain + "/logout", "_blank", windowFeatures);
    }
};